// extracted by mini-css-extract-plugin
export default {"head":"header_head__m-MR5","date":"header_date__fO1xr","text":"header_text__z4L23","iconButton":"header_iconButton__fmlkC"};